import { toast } from "react-toastify";

export const handleCopy = async (content:string) => {
  

    if (!navigator.clipboard) {
        toast.warn('Clipboard API not supported in this browser.')
      return;
    }

    // Optional: check secure context (though most modern apps are HTTPS)
    if (!window.isSecureContext) {
        toast.warn('Copy only works on HTTPS pages.')

      return;
    }

    try {
      await navigator.clipboard.writeText(content);
      toast.success('Copied')
    } catch (err) {
      console.error("Failed to copy:", err);
      toast.error('Failed to copy URL. Please try manually.')
    }
  };